import idx from 'idx';
import { connect } from 'react-redux';
import { toggleAddModal } from 'presentations/ducks';
import New from 'presentations/components/new';

const mapStateToProps = (state) => {
  return {
    presentations: idx(state, _ => _.project.presentations.presentations) || []
  };
}

export default connect(mapStateToProps, { toggleAddModal })(New);



// WEBPACK FOOTER //
// ./presentations/containers/new.js